import React, { useDebugValue, useEffect, useState } from "react";
import { Table, Modal, message,Popconfirm,Select, EditFilled, useSelector, PlusOutlined, CloseOutlined, Row, Col, useDispatch, Tree, Form, Input, Switch, Button, Drawer, Divider, Radio, DeleteFilled, SearchOutlined, UserAddOutlined, Checkbox,MinusOutlined } from '../../../AntComponent';

import { useNavigate } from 'react-router-dom';
import { addUserGroup, addUserMember, associateServices,serviceUserGroup,UpdateServiceUserGroup, assoMemList, deleteMember, memberList } from "../../../../store/actions/security/userGroupAction";

const { TextArea } = Input;
const { DirectoryTree, TreeNode } = Tree;

export default function ViewUserGroup(props) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [openMemeber, setOpenMember] = useState(false);
  const [addMemDrawer, setAddMemDrawer] = useState(false);
  const [featureDrawer, setFeatureDrawer] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState(['0-0-0', '0-0-1']);
  const [checkedKeys, setCheckedKeys] = useState();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const data = props.data.rowData;
  const isDefault = props.data.isDefault;
  const { memberData, associateMem, assSrvInfo,grpSrvInfo,success2,success8,success4,success11,upGrpSrvInfo } = useSelector(state => state.userGroup);
  const serviceArr = grpSrvInfo?.data;
  const [showSuccessmsg1, setShowsuccessmsg1] = useState(false);
  const successmsg1 = showSuccessmsg1 ? success2 : null;
  const [showSuccessmsg, setShowsuccessmsg] = useState(false);
  const successmsg = showSuccessmsg ? success8 : null;
  const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
  const successmsg2 = showSuccessmsg2 ? success4 : null;
  const [showSuccessmsg3, setShowsuccessmsg3] = useState(false);
  const successmsg3 = showSuccessmsg3 ? success11 : null;
  const [showSuccessmsg4, setShowsuccessmsg4] = useState(false);
  const successmsg4 = showSuccessmsg4 ? success11 : null;
  const [tempService, setTempService] = useState([]);
  const onCheck = (checkedKeysValue) => {
    // console.log('onCheck', checkedKeysValue);
    setCheckedKeys(checkedKeysValue.checked);
  };

  const memberOptions = memberData?.data.map((item) => {
    return (
      {
        label: item.fullName,
        value: item.appUserID,
        key: item.appUserID
      }
    )
  });

 useEffect(()=>{
  let c=[];
  if(assSrvInfo?.data){
    for(let i=0;i<assSrvInfo?.data.length;i++){
      if(assSrvInfo.data[i].isAssociate==true && assSrvInfo.data[i].subMenu==0){
        c.push(assSrvInfo.data[i].entServiceId.toString());
        
      }else{
        if(assSrvInfo.data[i].isAssociate==true){
          c.push(assSrvInfo.data[i].entServiceId.toString());
          let d=assSrvInfo.data[i].subMenu;
          for(let j=0;j<d.length;j++){
            if(d[j].isAssociate==true){
              c.push(d[j].entServiceId.toString());
            }
          }
        }
      }
    }
  }
  setCheckedKeys(c);
 },[assSrvInfo]);

 const filteredArray = assSrvInfo?.data?.filter(
  (item) => item.isAssociate && item.subMenu !== null
);

  const roleServices = filteredArray?.map((item) => {
    if ( item.isAssociate) {
      if(item.subMenu.length > 0){
        for(let i=0;i<item.subMenu.length;i++){
          if(item.subMenu[i].isAssociate==true){
            return (
              {
                title: item.serviceName,
                key: item.entServiceId,
                type: "parent",
                children: item?.subMenu.map((itm) => {
              
                  return (
                    {
                      title: itm.serviceName,
                      key: itm.entServiceId,
                      type: "child",
                      // isLeaf:true
                      // children: []
                    }
                  )
                })
              }
             
            )
          }else{ return({
            title: item.serviceName,
            key: item.entServiceId,
            type: "parent",
            children: []
          })
          }
        }
     
      }
    else {
      // if(item.isAssociate==true){
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: []
        }
      )
      // }
      }
    }else{
      
    }
  });
   
  useEffect(() => {
    if (successmsg1) {
      message.success("Member Updated successfully");
      setShowsuccessmsg1(false);
      getAssociatedMember();
      // getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
    }
  }, [successmsg1]);

  useEffect(() => {
    if (successmsg) {
      message.success("Member removed successfully");
      setShowsuccessmsg(false);
      getAssociatedMember();
      // getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
    }
  }, [successmsg]);
  useEffect(() => {
    if (successmsg2) {
      message.success("Updated services successfully");
      setShowsuccessmsg2(false);
      getAssociatedServices();
      // getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
    }
  }, [successmsg2]);
  useEffect(() => {
    if (successmsg3) {
      if(upGrpSrvInfo?.statusCode ==200){
        message.success("Service Deleted successfully");
        setShowsuccessmsg3(false);
        getAssociatedServices();
      }
    }
  }, [successmsg3]);
  useEffect(()=>{
    if(successmsg4){
      if(upGrpSrvInfo?.statusCode ==200){
        message.success("Service Updated successfully");
        setShowsuccessmsg4(false);
        getAssociatedServices();
      }
    }
  },[successmsg4])

  const featureServices = assSrvInfo?.data?.map((item) => {
    if (item.subMenu.length == 0 ) {
      
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: []
        }
      )
    } else {
     
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: item?.subMenu.map((itm) => {
            return (
              {
                title: itm.serviceName,
                key: itm.entServiceId,
                type: "child",
                // isLeaf:true
                // children: []
              }
            )
          })
        }
      )
      }
  });

  const closeMember = () => {
    setOpenMember(false);
  }
  const openMembr = () => {
    setOpenMember(true);
    memberListData();
  }

  function openAddMemDrawer() {
    setAddMemDrawer(true);
    memberListData();
  }
  function closeAddMemDrawer() {
    setAddMemDrawer(false);
  }
  const openFeatureDrawer = () => {
    setFeatureDrawer(true);
  }
  const closeFeatureDrawer = () => {
    setFeatureDrawer(false);
  }
  const handleBack = () => {
    props.data.callbackFunction(false);
  }

  function memberListData() {
    let inputJson = {
      "ProductID": 1080,
      "TenantID": 1139,
      "RoleName": data.roleName,
      "UserGroupID": data.userGroupID,
      "IsMembersList": false
    }
    dispatch(memberList(inputJson));

  }
  const getAssociatedMember=()=>{
    let inputJson = {
      "ProductID": 1080,
      "TenantID": 1139,
      "UserGroupID": data.userGroupID,
      "IsMembersList": true
    }
    dispatch(assoMemList(inputJson));
  }
  useEffect(() => {
   getAssociatedMember();
  }, []);

  async function addMember() {
    let val = await form.validateFields();
    let inputJson = {
      "UserGroupID": data.userGroupID,
      "AppUserID": val.memberID
    }
    dispatch(addUserMember(inputJson));
    setShowsuccessmsg1(true);
    closeAddMemDrawer();
  }

  const handleMember = (value) => {
    // console.log("value")
  }

  function getAssociatedServices(){
    dispatch(serviceUserGroup(data.userGroupID));
    dispatch(associateServices(data.userGroupID));
  }
  useEffect(() => {
   getAssociatedServices();
  }, []);

  const renderTreeNodes = (data) =>
    data.map((item) => {
      if (item!==undefined && item.children) {
        return (
          <TreeNode className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0" key={item.key}>
                <div className="col-auto">
                  {item.title}
                </div>
                <div className="col-auto ms-auto pe-1">
                 
                </div>
              </div>
            }
          >
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }

      return (<TreeNode className={`${item.type}`} key={item.key} title={<div key={item.key}>{item.title}</div>} />);
    });

    const submitUserGroup = () => {
      let s=checkedKeys;
     
      for(let i=0;i<featureServices.length;i++){
        if(featureServices[i].children.length>0){
          for(let j=0;j<featureServices[i].children.length;j++){
            if(checkedKeys.length>0){
              for(let k=0;k<checkedKeys.length;k++){
                if(checkedKeys[k]==featureServices[i].children[j].key){
                 s.push(featureServices[i].key);
                }
              }
            }
          }
        }
      }
    
      const uniqueArray=[...new Set(s)];
     
      let inputJson = {
        "UserGroupID": data.userGroupID,
        "UserGroup": data.userGroup,
        "UserGroupDesc": data.userGroupDesc,
        "UserGroupStatus": data.userGroupStatus || "Active",
        "CreatedBy": 26,
        "TenantID": 1139,
        "ProductID": 1080,
        "UserTypeID": data.userTypeID,
        "RoleID": data.roleID,
        "EntServices": uniqueArray.toString()||""
      }
      dispatch(addUserGroup(inputJson));
      closeFeatureDrawer();
      setShowsuccessmsg2(true);
    }
// userGroupID,appUserID
    const removeMember=(val)=>{
      let id=`${data?.userGroupID}/${val.appUserID}`
      dispatch(deleteMember(id));
      setShowsuccessmsg(true);
    }

  const deleteServiceUserGroup=(val)=>{

    let inputJson=[{
      "EntServiceID": val.entServiceID,
      "UserGroupID": data.userGroupID,
      "ReadAccess": val.readAccess,
      "WriteAccess": val.writeAccess,
      "DeleteAccess": val.deleteAccess,
      "ApproveAccess": val.approveAccess,
      "ExportAccess": val.exportAccess,
      "IsType": "Delete",
    }]
    dispatch(UpdateServiceUserGroup(inputJson));
    setShowsuccessmsg3(true);
  }

  const updateService = (val, id, e) => {
    const checked = e.target.checked;

    const updatedTempService = tempService.map(item => {
      if (item.EntServiceID === val.entServiceID) {
        return {
          ...item,
          ReadAccess: id === 1 ? checked : item.ReadAccess,
          WriteAccess: id === 2 ? checked : item.WriteAccess,
          DeleteAccess: id === 3 ? checked : item.DeleteAccess,
          ApproveAccess: id === 4 ? checked : item.ApproveAccess,
          ExportAccess: id === 5 ? checked : item.ExportAccess,
        };
      }
      return item;
    });
    if (!tempService.find(item => item.EntServiceID === val.entServiceID)) {
      updatedTempService.push({
        "EntServiceID": val.entServiceID,
        "UserGroupID": data.userGroupID,
        "ReadAccess": id === 1 ? checked : val.readAccess,
        "WriteAccess": id === 2 ? checked : val.writeAccess,
        "DeleteAccess": id === 3 ? checked : val.deleteAccess,
        "ApproveAccess": id === 4 ? checked : val.approveAccess,
        "ExportAccess": id === 5 ? checked : val.exportAccess,
        "IsType": 'Update',
      });
    }
    setTempService(updatedTempService);
    // console.log(updatedTempService, "upate")
  }
  const updateGroupService =()=>{
    dispatch(UpdateServiceUserGroup(tempService));
    setShowsuccessmsg4(true);
    setTempService([]);
    getAssociatedServices();
  }

  return (
    <>
      <div className="d-flex">
        <h6 className="my-auto p-3">User Group Detail View</h6>
        <Button type="default" className="ms-auto mb-2" onClick={handleBack}>Back</Button>
      </div>

      <Divider className="mt-0" />
      <div className="bg-blue p-3">
        <div><span className="fw-bold">Group Name:</span> <span>{data.userGroup}</span></div>
        <div className="my-1"><span className="fw-bold">Group Description:</span> <span>{data.userGroupDesc}</span></div>
        <div className="d-flex w-75">
          <div><span className="fw-bold">User Type:</span> <span>{data.userType}</span></div>
          <div className="ms-5"><span className="fw-bold ms-auto">User Role:</span> <span>{data.roleName}</span></div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col bg-light px-2 py-3 me-2">
          <div className="bg-white p-3 h-100">
            <div className="d-flex mb-2">
              <h6 className='my-auto col-auto'>Group Members </h6>
              {/* <h6 className="ms-auto" onClick={() => openMembr()}><EditFilled /></h6> */}
              <div  onClick={() => openAddMemDrawer()} className="col-auto ms-auto text-primary pointer"><PlusOutlined className='me-1'> </PlusOutlined>Add Member</div>
            </div>
            {associateMem?.data.map((item,i) => {
              return (
                <div key={i} className="card border p-2 rounded-0">
                  <div className="d-flex">
                    <div> <label>{item.fullName} - Department Name 1</label></div>
                      <div className="ms-auto">
                        <span className="bg-danger my-auto text-center h-75">
                          <Popconfirm
                              placement="topLeft"
                              title="Are you sure to remove this member?"
                              onConfirm={() => removeMember(item)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <CloseOutlined className="text-white pb-1" />
                              
                          </Popconfirm>
                        </span>
                      </div>
                    </div>
                  </div>)
                })}
          </div>
        </div>
        <div className="col bg-light px-2 py-3">
          <div className="bg-white green-tree p-3 h-100">
            <div className="d-flex mb-2">
              <h6>Associated Features / Services</h6>
              <Button type="primary" className="ms-auto " onClick={openFeatureDrawer}>+ Associate Feature/Services</Button>
              {/* <h6 className="ms-auto" onClick={openFeatureDrawer}><EditFilled /></h6> */}
            </div>
            {/* {roleServices ? <Tree
              checkable
              checkStrictly
              defaultExpandAll
              // onSelect={onSelect}
              onCheck={onCheck}
              // className="draggable-tree1"
              // treeData={roleService}
              disabled 
              blockNode>{renderTreeNodes(roleServices)}</Tree> : ""} */}
            {/* <DirectoryTree
              checkStrictly
              checkable
              className="draggable-tree2 p-3"
              defaultExpandAll
              onSelect={onSelect}
              onExpand={onExpand}
              treeData={treeData1}
              disabled
            /> */}
            <table className="serviceTable w-100 mt-3 mb-2">
              <thead className="col-text service-tbl">
                  <tr className="tabs ">
                      <th className="service-head-name text-white text-left fw-bold">Service Name</th>
                      <th className="service-name text-white text-center fw-bold">Read</th>
                      <th className="service-name text-white text-center fw-bold">Write</th>
                      <th className="service-name text-white text-center fw-bold">Delete</th>
                      <th className="service-name text-white text-center fw-bold">Approve</th>
                      <th className="service-name text-white text-center fw-bold">Export</th>
                      <th className="service-name text-white text-center fw-bold"></th>
                  </tr>
              </thead>
                <tbody className="srv-tbody">
                    {serviceArr?.map((item) => {
                      return(
                        <React.Fragment key={item.srvUserGroupID}>
                            <tr className="parentRow">
                                <td className="tr-title darkGreen p-0 border-start border-bottom">
                                    <div className="p-2 pt-1">
                                        <span className="pe-2"><Checkbox disabled /></span>
                                        <span>{item.serviceName}</span>
                                    </div>
                                </td>
                                <td className="tr-title bg-white  p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                        {
                                            item.readAccess == null ?<span><MinusOutlined/></span>:
                                            <span className="pe-2"><Checkbox  defaultChecked={item.readAccess} onChange={(e)=>{updateService(item,1,e)}}/></span>
                                        }
                                    </div>
                                </td>
                                <td className="tr-title bg-white  p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                    {
                                        item.writeAccess == null ?<span><MinusOutlined/></span>:
                                        <span className="pe-2"><Checkbox  defaultChecked={item.writeAccess} onChange={(e)=>{updateService(item,2,e)}}/></span>
                                    }
                                    </div>
                                </td>
                                <td className="tr-title bg-white  p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                    {
                                        item.deleteAccess == null ?<span><MinusOutlined/></span>:
                                        <span className="pe-2"><Checkbox  defaultChecked={item.deleteAccess} onChange={(e)=>{updateService(item,3,e)}}/></span>
                                    }  
                                    </div>
                                </td>
                                <td className="tr-title bg-white  p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                    {
                                        item.approveAccess == null ?<span><MinusOutlined/></span>:
                                        <span className="pe-2"><Checkbox  defaultChecked={item.approveAccess} onChange={(e)=>{updateService(item,4,e)}}/></span>
                                    }  
                                    </div>
                                </td>
                                <td className="tr-title bg-white  p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                    {
                                        item.exportAccess == null ?<span><MinusOutlined/></span>:
                                        <span className="pe-2"><Checkbox  defaultChecked={item.exportAccess} onChange={(e)=>{updateService(item,5,e)}}/></span>
                                    } 
                                    </div>
                                </td>
                                
                                <td className="tr-title darkGreen p-0 border-start border-bottom">
                                    {!isDefault && (
                                        <div className="text-center bg-white">
                                          <Popconfirm
                                                  placement="topLeft"
                                                  title="Are you sure you want to delete this service?"
                                                  onConfirm={() => deleteServiceUserGroup(item)}
                                                  okText="Yes"
                                                  cancelText="No"
                                                >
                                                <i className="fa fa-times bg-danger text-white delIcon"><CloseOutlined/> </i>
                                          </Popconfirm>
                                        </div>
                                    )}
                                </td>
                            </tr>
                            {/* Sub items */}
                            {item.objuser?.map((sub) => (
                                <tr key={sub.srvUserGroupID} className="parentRow">
                                    <td className="me-3 p-0 border-0 first-child">
                                        <div className="ms-3 p-2 pt-1 border-start border-bottom fc">
                                            <span className="pe-2"><Checkbox disabled/></span>
                                          <span>{sub.serviceName}</span>
                                        </div>
                                    </td>
                                    <td className="tr-title bg-white p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                      {
                                          sub.readAccess == null ?<span><MinusOutlined/></span>:
                                          <span className="pe-2"><Checkbox  defaultChecked={sub.readAccess} onChange={(e)=>{updateService(sub,1,e)}}/></span>
                                      } 
                                    </div>
                                </td>
                                <td className="tr-title bg-white p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                      {
                                          sub.writeAccess == null ?<span><MinusOutlined/></span>:
                                          <span className="pe-2"><Checkbox  defaultChecked={sub.writeAccess} onChange={(e)=>{updateService(sub,2,e)}}/></span>
                                      } 
                                    </div>
                                </td>
                                <td className="tr-title bg-white p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                      {
                                          sub.deleteAccess == null ?<span><MinusOutlined/></span>:
                                          <span className="pe-2"><Checkbox  defaultChecked={sub.deleteAccess} onChange={(e)=>{updateService(sub,3,e)}}/></span>
                                      } 
                                    </div>
                                </td>
                                <td className="tr-title bg-white p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                      {
                                          sub.approveAccess == null ?<span><MinusOutlined/></span>:
                                          <span className="pe-2"><Checkbox  defaultChecked={sub.approveAccess} onChange={(e)=>{updateService(sub,4,e)}}/></span>
                                      } 
                                    </div>
                                </td>
                                <td className="tr-title bg-white p-0 border-start border-bottom">
                                    <div className="p-2 pt-1 text-center">
                                      {
                                          sub.exportAccess == null ?<span><MinusOutlined/></span>:
                                          <span className="pe-2"><Checkbox  defaultChecked={sub.exportAccess} onChange={(e)=>{updateService(sub,5,e)}}/></span>
                                      } 
                                    </div>
                                </td>
                                    <td className="tr-title bg-white p-0 border-start border-bottom">
                                        {!isDefault && (
                                            <div className="text-center bg-white">
                                              <Popconfirm
                                                  placement="topLeft"
                                                  title="Are you sure you want to delete this service?"
                                                  onConfirm={() => deleteServiceUserGroup(sub)}
                                                  okText="Yes"
                                                  cancelText="No"
                                                >
                                                <i className="fa fa-times bg-danger text-white delIcon"><CloseOutlined/> </i>
                                              </Popconfirm>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </React.Fragment>
                    )})}
              </tbody>
            </table>
            <div className="row">
              <div className="col-auto ms-auto text-end mt-2">
                <Button type="primary" className="primary dlv-save-btn" onClick={()=>updateGroupService()}>Save</Button>
              </div>
            </div>
        
          </div>
        </div>
      </div>
      <Drawer title="Add/Remove Member" width={560} placement="right" onClose={closeMember} open={openMemeber}>
        <div className="bg-blue p-3">
          <div><span className="fw-bold">Group Name:</span> <span>{data.userGroup}</span></div>
          <div><span className="fw-bold">Group Description:</span> <span>{data.userGroupDesc}</span></div>
          <div className="d-flex">
            <div><span className="fw-bold">User Type:</span> <span>{data.userType}</span></div>
            <div><span className="fw-bold">User Role:</span> <span>{data.roleName}</span></div>
          </div>
        </div>
        <div className="d-flex mt-3 mb-2">
          <h6>Group Members</h6>
          <p className="ms-auto" onClick={() => openAddMemDrawer()}> + Add Member</p>
        </div>
        {associateMem?.data.map((item) => {
          return (
            <div className="card border p-2 rounded-0">
              <div className="d-flex">
                <div> <label>{item.fullName} </label></div>
                <div className="ms-auto"><span className="bg-danger my-auto text-center h-75">
                <Popconfirm
                            placement="topLeft"
                            title="Are you sure to remove this member?"
                            onConfirm={() => removeMember(item)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <CloseOutlined className="text-white " />
                        </Popconfirm>
                
                  </span></div>
              </div>
            </div>)
        })}
        <div className="mt-4 text-end">
          <Button type="default" className="me-2 col-auto ms-auto" danger onClick={() => closeMember()}>Cancel</Button>
          <Button type="primary" className="me-0 col-auto">Save</Button>
        </div>
      </Drawer>
      <Drawer title="Enable/Disable User Group - Features/Services" width={560} placement="right" onClose={closeFeatureDrawer} open={featureDrawer}>
        <div className="bg-blue p-3">
          <div><span className="fw-bold">Group Name:</span> <span>{data.userGroup}</span></div>
          <div className="my-1"><span className="fw-bold">Group Description:</span> <span>{data.userGroupDesc}</span></div>
          <div className="d-flex">
            <div><span className="fw-bold">User Type:</span> <span>{data.userType}</span></div>
            <div className="ms-4"><span className="fw-bold">User Role:</span> <span>{data.roleName}</span></div>
          </div>
        </div>
        <div className="d-flex mt-3 mb-2 ">
          <h6>Check all the features/Services to this user group</h6>
        </div>
        <div className="green-tree">
        {featureServices ? <Tree
              checkable
              checkStrictly
              defaultExpandAll
              defaultCheckedKeys={checkedKeys}
              // onSelect={onSelect}
              onCheck={onCheck}
              className="draggable-tree1"
              // treeData={roleService}
              
              blockNode>{renderTreeNodes(featureServices)}</Tree> : ""}
              </div>
        {/* <DirectoryTree
          className="draggable-tree2 p-3"
          defaultExpandAll
          onSelect={onSelect}
          onExpand={onExpand}
          treeData={treeData1}
        // disabled
        /> */}

        <div className="mt-4 text-end">
          <Button type="default" className="me-2 col-auto ms-auto" onClick={()=>closeFeatureDrawer()} danger>Cancel</Button>
          <Button type="primary" className="me-0 col-auto" onClick={submitUserGroup}>Update</Button>
        </div>
      </Drawer>
      <Modal title="Add Member" open={addMemDrawer} onOk={addMember} onCancel={() => closeAddMemDrawer()}>
        <Divider className="mb-3 mt-1" />
        <Form form={form} layout="vertical">
          <Form.Item label="Choose Member" name="memberID">
            <Select className="w-100 mb-3 " options={memberOptions} onChange={handleMember} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}